<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-size-75">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
          <div class="card-icon">
            <md-icon>{{ quoteIcon }}</md-icon>
          </div>
        </md-card-header>

        <md-card-content>
          <form class="form-horizontal" action method="post">
            <div
              v-if="quote.quoteStatusId === 1"
              class="md-layout-item md-medium-size-100 md-size-40"
            >
              <md-field>
                <label>Value (&#163;)</label>
                <md-input v-model="quote.value" required></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-medium-size-100 md-size-80">
              <md-field>
                <label>Decription</label>
                <md-textarea
                  v-model="quote.description"
                  md-autogrow
                  required
                ></md-textarea>
              </md-field>
            </div>
            <div
              v-if="quote.quoteStatusId > 1"
              class="md-layout-item md-medium-size-100 md-size-50"
            >
              <md-field>
                <label for="type">Priority</label>
                <md-select v-model="quote.quotePriorityId" required>
                  <md-option
                    v-for="quotePriority in quotePriorities"
                    :key="quotePriority.id"
                    :value="quotePriority.id"
                    >{{ quotePriority.name }}</md-option
                  >
                </md-select>
              </md-field>
            </div>
          </form>
        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button
            native-type="submit"
            @click.native.prevent="onSubmit"
            class="md-success md-sm"
            :disabled="hasSubmit"
            ><md-icon class="material-icons">check</md-icon>Submit</md-button
          >
          <md-button class="md-danger md-sm" @click="onCancel"
            ><md-icon class="material-icons">close</md-icon>Cancel</md-button
          >
        </md-card-actions>
      </md-card>
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-25"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      quoteIcon: "quote/icon",
      quote: "quote/quote",
      quotePriorities: "quote/getListOfQuotePriorities"
    })
  },
  async created() {
    await this.getQuoteDetails();
  },
  data() {
    return {
      hasSubmit: false
    };
  },
  methods: {
    async getQuoteDetails() {
      await this.$store.dispatch(
        "quote/getQuoteDetail",
        this.$route.params.quoteId
      );
    },
    onCancel() {
      this.hasSubmit = false;
      this.$router.go(-1);
    },
    onSubmit() {
      this.hasSubmit = true;
      this.$store
        .dispatch("quote/updateQuote", {
          form: this.generateForm()
        })
        .then(() => {
          this.$router.push({
            name: "Quote",
            params: { quoteId: this.$route.params.quoteId }
          });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status === 400) {
            // handle validation error
            let validationErrorDictionary = error.response.data.errors;
            for (var fieldName in validationErrorDictionary) {
              if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                errors.push("- " + validationErrorDictionary[fieldName]);
              }
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    },
    generateForm() {
      return {
        id: this.$route.params.quoteId,
        description: this.quote ? this.quote.description : "",
        value: this.quote ? parseFloat(this.quote.value) : 0,
        quotePriorityId: this.quote ? Number(this.quote.quotePriorityId) : 0
      };
    }
  }
};
</script>

<style></style>
